import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import DynamicLandingPage from "./pages/DynamicLandingPage";
import MentorEditPage from "./pages/MentorEditPage";
import LoginPage from "./pages/LoginPage";
import LegacyRedirect from "./components/LegacyRedirect";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./components/AdminLayout";

// Admin pages
import MentorsListPage from "./pages/admin/MentorsListPage";
import MentorFormPage from "./pages/admin/MentorFormPage";
import CampaignsPage from "./pages/admin/CampaignsPage";
import ActionsPage from "./pages/admin/ActionsPage";
import CSVPage from "./pages/admin/CSVPage";
import AnalyticsPage from "./pages/admin/AnalyticsPage";
import TemplatesPage from "./pages/admin/TemplatesPage";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            
            {/* Mentor edit panel with magic token (campaign-aware) */}
            <Route path="/edit/:campaign/:slug" element={<MentorEditPage />} />
            {/* Legacy edit route - defaults to cpn campaign */}
            <Route path="/edit/:slug" element={<MentorEditPage />} />
            
            {/* Admin routes (protected) */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <MentorsListPage />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/mentor/new"
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <MentorFormPage />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/mentor/:id"
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <MentorFormPage />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/campaigns"
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <CampaignsPage />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/actions"
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <ActionsPage />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/csv"
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <CSVPage />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/analytics"
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <AnalyticsPage />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/templates"
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <TemplatesPage />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            
            {/* Dynamic mentor landing - multi-campaign (MUST be before legacy) */}
            <Route path="/:campaign/:slug" element={<DynamicLandingPage />} />
            
            {/* Legacy redirect - old URLs without campaign */}
            <Route path="/:slug" element={<LegacyRedirect />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;